import React, { Component } from 'react';
import '../css/tablesPOS.css';
import Pagination from './Pagination';



class InventoryModal extends Component {

    
    

    ChangeValue(value) {
        // let itemArray;
        // if (!value) {
        //     itemArray = inventory.items || [];
        // }else{
        //     itemArray = inventory.items.length > 0 && inventory.items.filter((item)=>(item.ItemLine === value))
        // }
        // this.setState({
        //     itemArray,
        //     line: value
        // });
        
    }

    

    DoSearch = async (data,searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            if (tableReg.rows[i].classList.contains("noSearch")) {
                continue;
            }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR=tableReg.rows[tableReg.rows.length-1];
        const td=lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText == "") {
            lastTR.classList.add("hide");
        } else if (total) {
            td.innerHTML="Se ha encontrado "+total+" coincidencia"+((total>1)?"s":"");
        } else {
            lastTR.classList.add("red");
            td.innerHTML="No se han encontrado coincidencias";
        }
    }
    

    render() {
        const {InventoryData, InventoryDataTotalRows, ShowInventoryModal, GetInventoryData} = this.props;
        return (
            <div className="modal fade  modal-fullscreen" id="inventoryModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="inventoryModalLabel" aria-hidden="true">
                <div className="modal-dialog" >
                    <div className="modal-content">
                    <div className="modal-header" style={{background: "#343a40"}}>
                        <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{color: "white"}} onClick={ShowInventoryModal}>
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row m-3">
                            <h3 className="modal-title ml-3 mb-2 mt-3" id="inventoryModalLabel">Inventario</h3>
                        </div>
                        <div className="mt-3 card" style={{maxHeight: "630px"}}>
                            <div className="row m-3">
                                <div className="col-3">
                                <input 
                                    type="text" 
                                    className="form-control " 
                                    placeholder="Buscar" 
                                    id="itemISearch" 
                                    onKeyUp={()=>this.DoSearch("itemsData","itemISearch")} />
                                </div>
                                <div className="col-3">
                                    {/* <select 
                                        className="custom-select smr-sm-2" 
                                        value={line}
                                        onChange={(event)=>this.ChangeValue(event.target.value)}>
                                        <option value={''}>Departamento</option>
                                        {!!inventory.items && inventory.items.map((item, index) => {
                                            return (
                                                <option value={item.ItemLine}>{item.ItemLine}</option>
                                            )
                                        })}
                                        
                                    </select> */}
                                </div>
                                <div className="col-6 text-right" >
                                    {/* <span style={{fontSize: "22px"}}><i className="fa fa-money m-2" aria-hidden="true"/>Costo: $50</span> */}
                                </div>
                            </div>
                           
                            <div className='scrollTable' >
                                <table className="table table-striped table-hover" id="itemsData" style={{border:" 1px solid rgba(0, 0, 0, 0.125)", borderRadius: "0.25rem" }}>
                                    <thead>
                                        <tr>
                                            <th>Código</th>
                                            {/* <th>SKU</th> */}
                                            <th>Descripción</th>
                                            <th>P. Venta</th>
                                            <th>P. Mayoreo</th>
                                            <th>Existencia</th>
                                            <th>Departamento</th>
                                            <th>IVA</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {!!InventoryData && InventoryData.map((item, index) =>{ 
                                            return (
                                                <tr key={`inventory${item.ItemCode+index}`}>
                                                    {/* <td className="text-center"><input type="checkbox"/></td> */}
                                                    <th>{item.ItemCode}</th>
                                                    {/* <td>{item.ItemSKU}</td> */}
                                                    <td>{item.ItemName}</td>
                                                    <td className="noSearch">{item.AvgPrice}</td>
                                                    <td className="noSearch">{item.ItemWholesalePrice}</td>
                                                    <td className="noSearch">{item.OnHand}</td>
                                                    <td className="noSearch">{item.ItemLine}</td>
                                                    <td className="noSearch">{item.TaxCodeAR}</td>
                                                </tr>
                                            )
                                        })}
                                        <tr className='noSearch hide'>
                                            <td colSpan="8"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="">
                            {/* <ul className="pagination m-2 justify-content-end">
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                <li className="page-item"><a className="page-link" href="#">1</a></li>
                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul> */}
                            {InventoryDataTotalRows > 3 && 
                            <Pagination 
                                refresh ={GetInventoryData}
                                totalRowsRefresh = {InventoryDataTotalRows}/>
                            }
                        </div>
                        




                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-dismiss="modal">Eliminar</button>
                        <button type="button" className="btn btn-success">Guardar</button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InventoryModal;